import moment from 'moment';
import React from "react";
import { useSelector } from 'react-redux';

const universalSorter = (valueA, valueB, profile) => {
    const extractText = (val) => {
        if (React.isValidElement(val)) {
            val = val.props?.children ?? '';
        }
        if (Array.isArray(val)) {
            val = val.map(child => {
                if (React.isValidElement(child)) {
                    return child.props?.children ?? '';
                }
                return child;
            }).join(' ');
        }
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            const trimmed = val.trim();
            if (profile?.dateFormate && moment(trimmed, profile.dateFormate, true).isValid()) {
                return moment(trimmed, profile.dateFormate, true).toDate().getTime();
            }
            const cleaned = trimmed
                .replace(/^[^\d-]+/, '')
                .replace(/,/g, '')
                .replace(/\s+/g, '');
            const numberMatch = cleaned.match(/^(\d+(\.\d+)?)/);
            if (numberMatch) {
                return parseFloat(numberMatch[0]);
            }
            return trimmed.toLowerCase();
        }
        return '';
    };
    const a = extractText(valueA);
    const b = extractText(valueB);
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true });
};
export const generateDynamicColumns = (checkboxValues, ViewDetailPage, sortedInfo) => {
    let columns = [];
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    if (checkboxValues !== undefined) {
        columns = checkboxValues
            .filter((item) => item.isChecked)
            .map((item) => {
                const column = {
                    title: item.name,
                    dataIndex: item.FieldValue,
                    key: item.FieldValue,
                    sortDirections: ['ascend', 'descend'],
                    sortOrder: sortedInfo?.column?.dataIndex === item.FieldValue ? sortedInfo?.order : null
                };
                switch (item.FieldValue) {
                    case 'accountname':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (record?.LinkAccount) {
                                    ViewDetailPage(record.accountID, "ACCOUNT")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.accountname.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children : '';
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'reportingto':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (record?.linkContact) {
                                    ViewDetailPage(record.contactIDRTO, "CONTACT")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const children = item?.reportingto?.props?.children || [];
                                const figcaption = children.find(child => child && child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a) || '';
                            const valueB = extractNameText(b) || '';
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'contactowner':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (Role === "Administrator" || profile.userId === record.userId) {
                                    ViewDetailPage(record.userId, "USER")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.contactowner.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'name':
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.name.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    default:
                        column.sorter = (a, b) => {
                            const valueA = a[item.FieldValue]?.props?.children || '';
                            const valueB = b[item.FieldValue]?.props?.children || '';
                            return universalSorter(valueA, valueB, profile);
                        };
                        break;
                }
                return column;
            });
    }
    return columns;
};
export const generateUsersTableData = (exportData) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const usersTableData = [];
    if (exportData && exportData[0] !== "") {
        exportData.forEach((contact, key) => {
            usersTableData.push({
                LinkAccount: contact.accountPermission,
                linkContact: contact.reportingToPermission,
                ContactDataForPermission: contact,
                SharingData: contact?.sharingPermission?.sharePermission,
                sharingid: contact.fromId,
                userId: contact.lead_owner,
                accountID: contact.account_id,
                contactIDRTO: contact.reporting_to ? contact.reporting_to : contact.contacts_id,
                key: contact.contacts_id,
                no: key + 1,
                name: (
                    <div className="user-info_image table_list_clicks">
                        {contact.contacts_id && (contact.contact_profile !== null && contact.contact_profile !== undefined && contact.contact_profile !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={contact.contact_profile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag ContactIcon'>
                                {contact.first_name && contact.first_name.slice(0, 1).toUpperCase()}
                            </span>)
                        }
                        {contact.contacts_id &&
                            <figcaption>
                                <div>
                                    {`${contact.first_name} ${contact.last_name}`}
                                </div>
                                <div className='entityemail'>
                                    {contact.email}
                                </div>
                            </figcaption>
                        }
                    </div >
                ),
                accountname: (<div className={`user-info_image ${contact.accountPermission && "ListNavigate"}`}>
                    {contact.account_id &&
                        (contact.account_profile !== null && contact.account_profile !== undefined && contact.account_profile !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={contact.account_profile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag AccountIcon'>
                                {contact?.account_name?.slice(0, 1).toUpperCase()}
                            </span>)
                    }
                    {contact.account_id &&
                        <figcaption>
                            <div>
                                {contact.account_name}
                            </div>
                            <div className='entityemail'>
                                {contact.account_number}
                            </div>
                        </figcaption>
                    }
                </div>),
                contactowner: (<div className={`user-info_image ${(Role === "Administrator" || profile.userId === contact.lead_owner) && "ListNavigate"}`}>
                    {contact.lead_owner && (contact.userProfilePic !== null && contact.userProfilePic !== undefined && contact.userProfilePic !== "" ?
                        < figure >
                            <img style={{ width: "30px", height: "30px" }} src={contact.userProfilePic} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag UserIcon'>
                            {contact.userFirstName && contact.userFirstName.slice(0, 1).toUpperCase()}
                        </span>)
                    }
                    {contact.lead_owner &&
                        <figcaption>
                            <div>
                                {`${contact.userFirstName} ${contact.userLastName}`}
                            </div>
                            <div className='entityemail'>
                                {contact.leadOwner}
                            </div>
                        </figcaption>
                    }
                </div>),
                reportingto: (<div className={`user-info_image ${contact.reportingToPermission && "ListNavigate"}`}>
                    {contact.reporting_to && (contact.reportingToProfilePic !== null && contact.reportingToProfilePic !== undefined && contact.reportingToProfilePic !== "" ?
                        < figure >
                            <img style={{ width: "30px", height: "30px" }} src={contact.reportingToProfilePic} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag ContactIcon'>
                            {contact?.reportingToFirstName?.slice(0, 1).toUpperCase()}
                        </span>
                    )}
                    {contact.reporting_to &&
                        <figcaption>
                            <div>
                                {`${contact.reportingToFirstName} ${contact.reportingToLastName}`}
                            </div>
                            <div className='entityemail'>
                                {contact.reportingTo}
                            </div>
                        </figcaption>
                    }
                </div>),
                seniorityLevel: (
                    <div
                        className='table_list_clicks'
                    >{contact.seniorityLevel}
                    </div>
                ),
                contactsource: (<div className='table_list_clicks status-text LeadSource'>{contact.contactSourceName}</div>),
                title: (<div className='table_list_clicks'>{contact.title}</div>),
                designation: (<div className='table_list_clicks'>{contact.designation}</div>),
                phone: (<div className='table_list_clicks'>{contact.phone}</div>),
                fax: (<div className='table_list_clicks'>{contact.fax}</div>),
                mobile: (<div className='table_list_clicks'>{contact.mobile}</div>),
                description: (<div className='table_list_clicks'>{contact.description ? `${contact.description.substring(0, 50)}...` : contact.description}</div>),
                emailoptout: (<div className='table_list_clicks'>{contact.email_otp_out === 0 ? "No" : contact.email_otp_out === 1 && "Yes"}</div>),
                country: (<div className='table_list_clicks'>{contact.country}</div>),
                state: (<div className='table_list_clicks'>{contact.state}</div>),
                city: (<div className='table_list_clicks'>{contact.city}</div>),
                street: (<div className='table_list_clicks'>{contact.street}</div>),
                zipCode: (<div className='table_list_clicks'>{contact.postcode}</div>),
                email: (<div className='table_list_clicks'>{contact.email}</div>),
                assistantcontactnumber: (<div className='table_list_clicks'>{contact.assitant_contact_number}</div>),
                assistantname: (<div className='table_list_clicks'>{contact.assitant_name}</div>),
                department: (<div className='table_list_clicks' >{contact.department}</div>),
                createdby: (<div className='table_list_clicks'>
                    {contact?.created_at}
                </div>),
                modifiedby: (<div className='table_list_clicks'>
                    {contact?.modified_at}
                </div>),
                contactScore: (
                    <div className='table_list_clicks'>
                        {Number(contact?.contact_score)?.toFixed(2)}
                    </div>
                ),
                linkedinUrl: (
                    <div className='table_list_clicks'>
                        {contact?.linkedin_url}
                    </div>
                ),
            })
        })
    }
    return usersTableData;
};
